import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import Header from '../../blocks/header/scripts';
import Hero from '../../blocks/hero/scripts';
import ButtonHover from '../../blocks/button/scripts';
import SliderBrand from '../../blocks/slider-brand/scripts';
import Testimonials from '../../blocks/testimonials/scripts';
import ProjectsList from '../../blocks/projects-list/scripts';
import BlogList from '../../blocks/blog-list/scripts';
import Contact from '../../blocks/contact/scripts';
import Media from '../../blocks/media/scripts';
import TextImg from '../../blocks/text-img/scripts';
import DoubleImg from '../../blocks/double-img/scripts'
import Cards from '../../blocks/cards/scripts';
import PictoList from '../../blocks/picto-list/scripts';

document.addEventListener('DOMContentLoaded', () => {

  gsap.registerPlugin(ScrollTrigger, SplitText)

  document.querySelectorAll('.splittext').forEach(wrapper => {
    const targets = wrapper.querySelectorAll('p, h1, h2, h3, span')
    targets.forEach(target => {
      const split = new SplitText(target, { type: 'lines', linesClass: 'split-line' })
      gsap.fromTo(split.lines,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: wrapper,
            start: 'top 85%',
            toggleActions: 'play none none none',
          }
        }
      )
    })
  })

  const lenis = new Lenis()
  lenis.on('scroll', ScrollTrigger.update)
  gsap.ticker.add((time) => lenis.raf(time * 700))
  gsap.ticker.lagSmoothing(0)

  const header = document.querySelector('.header')
  if (header) new Header(header)

  const hero = document.querySelector('.hero')
  if (hero) new Hero(hero)

  const buttonElements = document.querySelectorAll('[data-block="button"]');
  buttonElements.forEach((buttonElement) => {
    new ButtonHover(buttonElement);
  });

  const sliderBrandElements = document.querySelectorAll('[data-block="slider-brand"]');
  sliderBrandElements.forEach((el) => {
    new SliderBrand(el);
  });

  document.querySelectorAll('[data-block="projects-list"]').forEach(el => new ProjectsList(el));
  document.querySelectorAll('[data-block="blog-list"]').forEach(el => new BlogList(el));
  document.querySelectorAll('.contact').forEach(el => new Contact(el));
  document.querySelectorAll('[data-block="media"]').forEach(el => new Media(el))
  document.querySelectorAll('.text-img').forEach(el => new TextImg(el))
  document.querySelectorAll('.double-img').forEach(el => new DoubleImg(el))
  document.querySelectorAll('.cards').forEach(el => new Cards(el))
  document.querySelectorAll('.picto-list').forEach(el => new PictoList(el))

;

  const testimonialsQuotes = document.querySelectorAll('[data-block="testimonials-quotes"]');
  testimonialsQuotes.forEach((quotesEl) => {
    const section = quotesEl.closest('.testimonials');
    const personsEl = section ? section.querySelector('[data-block="testimonials-persons"]') : null;
    new Testimonials(quotesEl, personsEl);
  });
});